import { HubFeature } from '@ats/api/cm';
import { LocDefs } from '@cm/core/localization';

export type CPCreqHistoryAdditionalAgreementSharedLocNames =
	'CPCReqHistoryAdditionalAgreementContentNoExpiration';

export const creqAdditionalAgreementSharedLocs: LocDefs<CPCreqHistoryAdditionalAgreementSharedLocNames> =
	{
		CPCReqHistoryAdditionalAgreementContentNoExpiration: {
			defaultValue: 'No Expiration',
			description: 'Content text for: No Expiration.',
			displayPath: 'History|Additional Agreement|No Expiration',
			portal: 'CP',
			displayType: 'Content',
			feature: HubFeature.OtherRequirement,
			htmlAllowed: false,
			shared: true,
			legacyName: 'OtherRequirement/History.AdditionalAgreement.Content.NoExpiration',
		},
	};
